import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/chi-siamo', label: 'Chi Siamo' },
    { path: '/servizi', label: 'Servizi' },
    { path: '/processo', label: 'Processo' },
    { path: '/sostenibilita', label: 'Sostenibilità' },
    { path: '/professionisti', label: 'Per Professionisti' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_copper-recovery/artifacts/u6wvh72q_F.I.R.M.png"
              alt="FIRM s.a.s."
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors hover:text-[var(--copper-primary)] ${
                  location.pathname === item.path
                    ? 'text-[var(--copper-primary)]'
                    : 'text-[var(--text-dark)]'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link to="/contatti">
              <Button
                className="bg-[var(--copper-primary)] hover:bg-[var(--copper-dark)] text-white"
              >
                Contattaci
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button - Animated Hamburger */}
          <button
            className="md:hidden p-2 relative w-10 h-10 flex items-center justify-center"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <div className="hamburger-menu">
                <span className="hamburger-line hamburger-line-1"></span>
                <span className="hamburger-line hamburger-line-2"></span>
                <span className="hamburger-line hamburger-line-3"></span>
              </div>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm font-medium transition-colors ${
                    location.pathname === item.path
                      ? 'text-[var(--copper-primary)]'
                      : 'text-[var(--text-dark)]'
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <Link to="/contatti" onClick={() => setIsMobileMenuOpen(false)}>
                <Button
                  className="bg-[var(--copper-primary)] hover:bg-[var(--copper-dark)] text-white w-full"
                >
                  Contattaci
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};